import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/layout/header/header.component';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { ToastComponent } from './shared/components/toast/toast.component';
import { AuthService } from './core/auth/auth.service';
import { PermissionsService } from './core/auth/permissions.service';
import { CandidateService } from './pages/onboarding/services/candidate.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, ToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  private readonly authService = inject(AuthService);
  private readonly permissionsService = inject(PermissionsService);
  private readonly candidateService = inject(CandidateService);
  private readonly router = inject(Router);

  readonly checkDone = signal<boolean>(false);

  constructor() {
    effect(() => {
      if (this.authService.isAuthenticated() && this.permissionsService.hasRole('solicitante')) {
        this.checkOnboardingRedirect();
      } else {
        this.checkDone.set(true);
      }
    });
  }

  private async checkOnboardingRedirect(): Promise<void> {
    try {
      const profile = await firstValueFrom(this.candidateService.getMyProfile());
      const currentUrl = this.router.url;
      const isOnboardingOrPerfil =
        currentUrl === '/onboarding' || currentUrl.startsWith('/mi-perfil');
      if (!profile.onboarding_completed && !isOnboardingOrPerfil) {
        await this.router.navigate(['/onboarding']);
      }
    } catch {
      // Ignorar errores de carga de perfil
    } finally {
      this.checkDone.set(true);
    }
  }
}
